
@switch (columnId) {
  @case ('name') {
    <lib-text-table-column>
      {{ element.name }}
    </lib-text-table-column>
  }
  @case ('valueNum') {
    @if (isCreate && element.isEditable) {
      @if (element.valueFormat === ValueFormatEnum.Dollar) {
        <div class="value-pre">$</div>
      }
      <div class="value-wrapper">
        @if (element.valueFormat === ValueFormatEnum.Dollar) {
          <input
            type="text"
            [libTwoDigitDecimalNumber]="true"
            [libTwoDigitDecimalNumberAllowZeroNotNegative]="true"
            [libTwoDigitDecimalNumberEmptyIsNull]="true"
            class="value-num-input"
            matInput
            [(ngModel)]="customFeeTypeValueMap[element.id]"
            (mousedown)="inputTouched = true;"
            [ngClass]="{'invalid-value': !isCustomValueValid()}"
            [disabled]="!element.isEnabled" />
        }
        @if (element.valueFormat === ValueFormatEnum.Percentage) {
          <input
            type="text"
            [libDecimalNumber]="true"
            [libDecimalNumberEmptyIsNull]="true"
            [libDecimalNumberAllowNegative]="false"
            class="value-num-input"
            matInput
            [(ngModel)]="customFeeTypeValueMap[element.id]"
            (mousedown)="inputTouched = true;"
            [ngClass]="{'invalid-value': !isCustomValueValid()}"
            [disabled]="!element.isEnabled" />
        }
        @if (element.valueFormat === ValueFormatEnum.NA) {
          <input
            type="text"
            [libDecimalNumber]="true"
            [libDecimalNumberEmptyIsNull]="true"
            [libDecimalNumberAllowNegative]="true"
            class="value-num-input"
            matInput
            [(ngModel)]="customFeeTypeValueMap[element.id]"
            (mousedown)="inputTouched = true;"
            [ngClass]="{'invalid-value': !isCustomValueValid()}"
            [disabled]="!element.isEnabled" />
        }
      </div>
      @if (element.valueFormat === ValueFormatEnum.Percentage) {
        <div class="value-post">%</div>
      }
    } @else {
      @if (element.valueFormat === ValueFormatEnum.Percentage) {
        <div>
          {{ element.valueNum | vituPercentage }}
        </div>
      }
      @if (element.valueFormat === ValueFormatEnum.Dollar) {
        <div>
          {{ element.valueNum | vituCurrencyUsd }}
        </div>
      }
      @if (element.valueFormat === ValueFormatEnum.NA) {
        <div>
          {{ element.valueNum ?? "—" }}
        </div>
      }
    }
    <lib-table-column-sort [key]="sortingKeyForValue"></lib-table-column-sort>
  }
  @case ('category') {
    <lib-text-table-column>
      {{ element.category }}
    </lib-text-table-column>
  }
  @case ('trigger') {
    <lib-text-table-column>
      {{ element.trigger }}
    </lib-text-table-column>
  }
  @case ('processor') {
    <lib-text-table-column>
      {{ element.processor }}
    </lib-text-table-column>
  }
  @case ('feeCollector') {
    <lib-text-table-column>
      {{ element.feeCollector }}
    </lib-text-table-column>
  }
  @case ('isAbsorbed') {
    <lib-vitu-slide-toggle
      [(checked)]="element.isAbsorbed"
      [disabled]="!isCreate || !element.canAbsorb">
    </lib-vitu-slide-toggle>
    <lib-table-column-sort [key]="sortingKeyForIsAbsorbed"></lib-table-column-sort>
  }
  @case ('isEnabled') {
    <lib-vitu-slide-toggle
      [(checked)]="element.isEnabled">
    </lib-vitu-slide-toggle>
  }
  @default {
  }
}
